/* Pre-search panel: Popular + Recent searches, shown when a search input is
   empty and focused. Recent searches persist in localStorage. No deps. */
(function () {
  var KEY = 'budli_recent_searches';
  var MAX = 6;

  function getRecent() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function saveRecent(q) {
    q = (q || '').trim();
    if (!q) return;
    var r = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    r.unshift(q);
    try { localStorage.setItem(KEY, JSON.stringify(r.slice(0, MAX))); } catch (e) {}
  }
  function esc(s) { return String(s).replace(/[<>&"]/g, function (c) { return { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c]; }); }

  // "android" / "4g" intent → dedicated collection. Conservative: only fires when
  // the query is essentially just that term (optionally with phone/mobile + a
  // used/refurbished prefix), so "samsung 4g", "android tablet", "5g android" etc.
  // are left as normal searches.
  function keywordTarget(raw) {
    var q = (raw || '').toLowerCase().trim().replace(/\s+/g, ' ');
    q = q.replace(/^(buy |used |second ?hand |refurbished |new )+/, '');
    q = q.replace(/( smart ?phones?| phones?| mobiles?)+$/, '').trim();
    if (q === 'android') return 'second-hand-android-phones';
    if (q === '4g') return 'second-hand-4g-phones';
    return null;
  }

  // Budget "under ₹X" queries → the matching budget collection (search redirects).
  function redirectTarget(raw) {
    var kw = keywordTarget(raw);
    if (kw) return kw;
    var q = (raw || '').toLowerCase();
    if (q.indexOf('under') < 0) return null;
    var nm = q.match(/under[^\d]*(\d{1,6})\s*(k)?/);
    if (!nm) return null;
    var n = parseInt(nm[1], 10);
    if (nm[2] || n < 100) n = n * 1000; // "10k" or "10" → 10000
    if (/laptop|notebook|macbook/.test(q)) {
      if (n <= 10000) return 'refurbished-laptops-under-10000';
      if (n <= 15000) return 'refurbished-laptops-under-15000';
      return 'refurbished-laptops-under-20000';
    }
    if (n <= 5000) return 'second-hand-mobile-under-5000';
    if (n <= 10000) return 'second-hand-mobile-under-10000';
    if (n <= 15000) return 'second-hand-phones-under-15000';
    return 'second-hand-phones-under-20000';
  }
  function checkPageRedirect() {
    if (location.pathname.indexOf('/search') !== 0) return;
    try {
      var q = new URLSearchParams(location.search).get('q');
      var t = redirectTarget(q);
      if (t) location.replace('/collections/' + t);
    } catch (e) {}
  }

  function renderRecent(pre) {
    var wrap = pre.querySelector('[data-recent-wrap]');
    var list = pre.querySelector('[data-recent-list]');
    if (!wrap || !list) return;
    var r = getRecent();
    if (!r.length) { wrap.hidden = true; return; }
    wrap.hidden = false;
    list.innerHTML = r.map(function (q) {
      return '<a class="bsearch-chip" href="/search?q=' + encodeURIComponent(q) + '">' + esc(q) + '</a>';
    }).join('');
  }

  function init(form) {
    if (form.dataset.prepanelReady) return;
    var input = form.querySelector('input[type="search"], .search__input');
    var pre = form.querySelector('[data-search-pre]');
    if (!input || !pre) return;
    form.dataset.prepanelReady = '1';

    function update() {
      var empty = !input.value.trim();
      pre.hidden = !(empty && document.activeElement === input);
    }
    input.addEventListener('focus', function () { renderRecent(pre); update(); });
    input.addEventListener('input', update);
    input.addEventListener('blur', function () { setTimeout(function () { pre.hidden = true; }, 160); });
    form.addEventListener('submit', function (e) {
      saveRecent(input.value);
      var t = redirectTarget(input.value);
      if (t) { e.preventDefault(); window.location.href = '/collections/' + t; }
    });

    var clear = pre.querySelector('[data-recent-clear]');
    if (clear) clear.addEventListener('click', function (e) {
      e.preventDefault();
      try { localStorage.removeItem(KEY); } catch (err) {}
      renderRecent(pre);
      input.focus();
    });
  }

  function boot() {
    checkPageRedirect();
    document.querySelectorAll('form.search, .mobile-search-form').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
